import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useHistory, Redirect, useLocation } from "react-router-dom";
import { Table, Spinner, Accordion, Card, Dropdown, Modal, DropdownButton } from 'react-bootstrap'
import './index.scss';
import "antd/dist/antd.min.css";
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

function NewBookCover({ getNewBookModal, closeNewBookModal, error, isLoading, createBookCover }) {
  const { userId, userToken, isAdmin, userEmail, userName, isStatus, userRole, languageCode } = useSelector((state) => state.auth);
  const dispatch = useDispatch()
  const location = useLocation();

  // create new book cover
  const [getBookCoverTitle, setBookCoverTitle] = useState('')
  const bookCoveeData = {
    title: getBookCoverTitle,
    userId: userId,
    userToken: userToken,
    userRole: userRole
  }

  return (
    <Modal className="new-book-Cover" show={getNewBookModal} onHide={closeNewBookModal} animation={false}>
  
      <Modal.Body>

        <IconButton
          style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '10px', zIndex: 111 }}
          onClick={closeNewBookModal}
        >
          <CloseIcon className="Header-close-modal-icon" />
        </IconButton>
        <div className="row">
          <div className="col-md-12">
            <h5 style={{ textAlign: 'center', padding: '10px' }}>New Cover</h5>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            {error &&
              <div className="alert alert-danger" style={{ padding: '10px', textAlign: 'center' }}>{error}</div>
            }
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label>Title</label>
              <input type="text" className="form-control" value={getBookCoverTitle}
                onChange={(e) => setBookCoverTitle(e.target.value)} />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <Button
                style={{ width: '100%', background: '#2c2245cf', color: '#f7f7f7' }}
                disabled={isLoading ? true : false}
                color="info"
                variant="contained"
                size="medium"
                onClick={() => { createBookCover(bookCoveeData) }}>
                {isLoading ? 'Loading...' : 'Submit'}
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>

  );
}

export default NewBookCover;
